import React from 'react'

import { Helmet } from 'react-helmet'
import ReactMarkdown from 'react-markdown'
import { withRouteData } from 'react-static'
import SbEditable from 'storyblok-react'

function Certifications({ story }) {
  const { content } = story

  return (
    <div>
      <Helmet>
        <title>{content && content.top[0].title}</title>
      </Helmet>
      {content &&
        content.top.map(el => (
          <SbEditable key={el._uid} content={el}>
            <div
              className='hero hero--small'
              style={{
                backgroundImage: `url(${el.image})`,
                backgroundPosition: `center ${el.image_offset ? `${el.image_offset}%` : '50%'}`,
              }}
            >
              <div className='hero__overlay' />
              <div className='wrapper'>
                <h1 className='hero__title hero--small__title'>{el.title}</h1>
              </div>
            </div>
          </SbEditable>
        ))}

      <div className='wrapper'>
        <div className='flex flex-col gap-5'>
          {content &&
            content.policies &&
            content.policies.map(certification => (
              <CertificationItem
                key={certification._uid}
                certification={certification.Content}
              />
            ))}
        </div>
      </div>
    </div>
  )
}

function CertificationItem({ certification }) {
  const link = certification.find(el => el.component === 'Link')
  const title = certification.find(el => el.component === 'Section Title')
  const description = certification.find(el => el.component === 'Rich Text')

  return (
    <div>
      <h4 className='text-4xl font-bold text-center'>{title.text}</h4>
      <hr />
      <div
        style={{ alignItems: 'stretch' }}
        className={`flex flex-wrap items-center flex-col`}
      >
        {/* @ts-expect-error - Types are incorrect */}
        <ReactMarkdown
          className='text-justify'
          source={description.markdown}
          renderers={{
            link: ({ node, ...props }) => (
              <a className='underline' {...props} />
            ),
            strong: ({ node, ...props }) => (
              <strong className='font-bold' {...props} />
            ),
          }}
        />
        <div className='flex items-center justify-center p-2'>
          {link && (
            <a
              target='_blank'
              href={link.file}
              rel='noopener noreferrer'
              className='button button--green'
            >
              {link.label}
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default withRouteData(Certifications)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Certifications.jsx